import styled from "styled-components";

export const CollectionListItem = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    > div {
        &:first-child {
            margin-right: 8px;
            display: inline-flex;
        }
    }
`;

export const ImportProgressWithUrlWrapper = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 10px;
        }
    }
`;

export const AddContentPreviewResultWrapper = styled.div<{ $noCursor: boolean, $enabled: boolean }>`
    overflow: hidden;
    height: ${({ $enabled }) => $enabled ? "0" : "auto"};
    transition: height .3s ease;
    cursor: ${({ $noCursor }) => !$noCursor ? "pointer" : "initial"};
`;

export const AddItemPreviewResToggle = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    
    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 8px;
        }
    }
`;

export const NoPreviewFoundWrapper = styled.div`
    padding: 16px 20px;
    border-radius: 6px;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.v3.colors.midYellow};
    background: ${({ theme }) => theme.v3.colors.lightYellow};
`;

/** The button renders as a block level flex box, so it needs centering rather than inheriting the wrapper's text-align */
export const NoPreviewFoundCTAWrapper = styled.div`
    display: flex;
    justify-content: center;
`;

/** Horizontal rule with the label sitting in the middle of it */
export const NoPreviewFoundDivider = styled.div`
    display: flex;
    align-items: center;

    > div {
        margin: 0 12px;
        white-space: nowrap;
    }

    &:before,
    &:after {
        content: "";
        flex: 1;
        height: 1px;
        background: ${({ theme }) => theme.v3.colors.grey88};
    }
`;

export const ContentResultIconWrapper = styled.div`
    display: flex;
    align-items: flex-start;

    > div {
        &:first-child {
            margin-top: 3px;
            margin-right: 12px;
        }
    }
`;